import React, { useEffect } from "react";
import { Head } from "@inertiajs/react";
import { Header, RegionalNav, NewsTicker, Footer } from "../components/layout";
import {
  Hero,
  ValueProp,
  ContentShowcase,
  Features,
  FAQ,
  Subscribe,
} from "../components/sections";
import { Button } from "../components/ui/Button";

export default function Home({ verifyEmailSuccess, error, siteKey, recaptchaEnabled }) {
  const backToHomePage = () => {
    window.location.href = "/";
  };

  // Scroll animation observer
  useEffect(() => {
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      // Make all elements visible immediately
      document.querySelectorAll(".scroll-animate").forEach((el) => {
        el.classList.add("visible");
      });
      return;
    }

    // Create intersection observer for scroll animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    // Observe all scroll-animate elements
    document.querySelectorAll(".scroll-animate").forEach((el) => {
      observer.observe(el);
    });

    // Trigger page load animations
    const animateOnLoadElements = document.querySelectorAll(".animate-on-load");
    animateOnLoadElements.forEach((el) => {
      el.classList.remove("animate-on-load");
    });

    return () => observer.disconnect();
  }, []);

  const renderMainContent = () => {
    if (verifyEmailSuccess) {
      return (
        <div id="main-content">
          <div class="text-center my-10">
            <h2 class="text-2xl font-semibold text-green-600">Email Verified Successfully!</h2>
            <p class="mt-4 text-gray-600">
              Thank you for verifying your email - you've been added to the mailing list.
            </p>

            <div class="mt-4">
              <Button type="submit" variant="primary" size="lg" onClick={backToHomePage}>
                Back to Home Page
              </Button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="main-content">
          <Hero siteKey={siteKey} recaptchaEnabled={recaptchaEnabled} />
          <ValueProp />
          <ContentShowcase />
          <Features />
          <FAQ />
          {/* Final Subscribe CTA */}
          <Subscribe siteKey={siteKey} recaptchaEnabled={recaptchaEnabled} />
        </div>
      );
    }
  };

  return (
    <>
      <Head title="The Arabian-Nubian Brief | Mining Intelligence Newsletter" />

      <main className="min-h-screen">
        {/* Skip to content link for accessibility */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-gold focus:text-ink focus:font-sans focus:font-semibold"
        >
          Skip to main content
        </a>

        <Header />

        <RegionalNav />

        {/* <NewsTicker /> */}

        {renderMainContent()}

        <Footer />
      </main>
    </>
  );
}
